import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13 30.5h22m-22-6h22m-22-6h22" stroke="currentColor" fill="none" /></svg>;